/* Quote text fills in word by word while the visitor scrolls down */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = (box) => {
    if (box._drFill) return;
    const text = box.querySelector('.dr-quote__text');
    if (!text) return;
    box._drFill = true;
    const words = [];
    const walk = (node) => {
      Array.from(node.childNodes).forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            const w = document.createElement('span');
            w.className = 'dr-fill__w';
            w.textContent = part;
            words.push(w);
            frag.appendChild(w);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) walk(n);
      });
    };
    walk(text);
    box.classList.add('dr-fill-on');
    if (reduce) return;
    const update = () => {
      const r = text.getBoundingClientRect();
      const vh = window.innerHeight;
      const start = vh * 0.9;
      const end = vh * 0.5;
      const total = r.height;
      const prog = Math.min(1, Math.max(0, (start - r.top) / (start - end + total * 0.7)));
      const f = prog * words.length * 1.0;
      words.forEach((w, i) => w.style.setProperty('--p', Math.min(1, Math.max(0, f - i + 1)).toFixed(3)));
    };
    let tick = false;
    const on = () => { if (tick) return; tick = true; requestAnimationFrame(() => { tick = false; update(); }); };
    window.addEventListener('scroll', on, { passive: true });
    window.addEventListener('resize', on);
    update();
  };
  const run = () => document.querySelectorAll('[data-dr-fill]').forEach(init);
  run();
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();
